import { createContext, useContext } from "react";

export type DrawerContextProps = {
  onClose?: () => void;
};
const DrawerContext = createContext<DrawerContextProps>(
  {} as DrawerContextProps
);

export default DrawerContext;
export const useDrawer = () => useContext(DrawerContext);
